<template>
    <div>
        <text>{{ getSpecOptionFrontEndName(subOption.name) }}</text>
        <text v-if="subOption['replacementPrice'] !== undefined && subOption.replacementPrice !== 0">{{
            formatPriceChange(subOption.replacementPrice) }}</text>
        <text v-else-if="subOption['replacementPrice'] === undefined && subOption.price != 0">{{ formatPriceChange(subOption.price)
            }}</text>
    </div>
</template>
<script>
import { getSpecOptionFrontEndName } from "@/utils/productName.utils";
export default {
    props: {
        subOption: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
    },
    methods: {
        getSpecOptionFrontEndName,
        formatPriceChange(price) {
            return price > 0 ? `+${price}` : price
        },
    }
}
</script>
<style lang="">

</style>
